import i18n from "i18next";
import { logError } from "./logger";

interface Translation {
  key: string;
  value: string;
}

const translate = (
  key: string,
  variables?: { [key: string]: string },
): string | undefined => {
  const translation = (VisitWidget.store.translations as Translation[]).find(
    (t) => t.key === key,
  );

  if (translation) {
    // use client specific translation if it exists for key.
    return translation.value;
  }

  let text = i18n.t(key);
  if (text) {
    if (!!variables) {
      const variableKeys = Object.keys(variables);
      variableKeys.forEach((variableKey) => {
        text = text.replace(`%{${variableKey}}`, variables[variableKey]);
      });
    }
    return text;
  } else {
    // This will cause acceptance tests to fail without affecting users
    logError(`No translation found for ${key}`);
  }
};

export { translate };
